<div class="bg-blueLow mb-2 p-3 rounded-1">
  <div class="mb-2" [innerHTML]="title"></div>

  <ng-container *ngFor="let id of productIds; let last = last">
    <div class="d-flex align-items-center" *ngrxLet="id | cobMeta as product">
      <lui-avatar [color]="product.color" size="48px">
        <mat-icon [svgIcon]="product.icon"></mat-icon>
      </lui-avatar>
      <p class="mat-body-strong ms-1">
        {{ product.title }}
      </p>
    </div>

    <mat-divider *ngIf="!last" class="my-2"></mat-divider>
  </ng-container>
</div>
